<div class="modal-wrapper">
    <div class="modal-header d-flex align-items-center justify-content-between">
        <h4 class="block-title mb-0">{{'Custom schedule'|translate}}</h4>
        <button class="material-icons" mat-dialog-close>close</button>
    </div>

    <div class="modal-content p4">
        <!-- Day blocks -->
        <div class="week-day-block" *ngFor="let day of scheduledDays; let dayIndex = index">
            <div class="label-wrapper">
                <mat-label>{{'Select Week-Day'|translate}}</mat-label>
                <span class="material-symbols-outlined" (click)="removeDay(dayIndex)" *ngIf="dayIndex > 0">
                    cancel
                </span>
            </div>
            <mat-form-field class="w-100" appearance="outline">
                <mat-select [(ngModel)]="day.day" placeholder="{{'Select'|translate}}">
                    <mat-option *ngFor="let availableDay of getAvailableDays(day.day)" [value]="availableDay">
                        {{availableDay}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="timing-block">
                <div class="time-block">
                    <div class="row custom-time">
                        <div class="col-md-6">
                            <mat-label>{{'From'|translate}} {{'Time'|translate}}</mat-label>
                            <input [owlDateTime]="dtFrom" [owlDateTimeTrigger]="dtFrom"
                                [(ngModel)]="day.timeSlot.fromTime">
                            <owl-date-time #dtFrom [pickerType]="'timer'" [pickerMode]="'dialog'"
                                [hour12Timer]="false"></owl-date-time>
                        </div>
                        <div class="col-md-6">
                            <mat-label>{{'To'|translate}} {{'Time'|translate}}</mat-label>
                            <input [owlDateTime]="dtTo" [owlDateTimeTrigger]="dtTo" [(ngModel)]="day.timeSlot.toTime">
                            <owl-date-time #dtTo [pickerType]="'timer'" [pickerMode]="'dialog'"
                                [hour12Timer]="false"></owl-date-time>
                        </div>
                    </div>
                </div>
                <button class="btn icon-btn" (click)="removeDay(dayIndex)">
                    <span class="material-symbols-outlined">delete</span>
                </button>

            </div>
            <button class="btn add-more" (click)="addNewDay()" *ngIf="scheduledDays.length < days.length">
                <span class="material-symbols-outlined">add_circle</span>
                {{'Add More'|translate}}
            </button>
        </div>

        <!-- Add Day Button -->

    </div>

    <div class="modal-footer">
        <div class="button-wrapper">
            <button class="btn btn-link" type="button" mat-dialog-close>
                {{'Cancel'|translate}}
            </button>
            <button class="btn btn-primary" type="button" (click)="applySchedule()">
                {{'Apply'|translate}}
            </button>
        </div>
    </div>
</div>